import { Button, Flex } from "@radix-ui/themes";
import { useAppSelector } from "@/app/appStore";
import { useLiveDelay } from "@/shared/hooks/useLiveDelay";
import { ReactComponent as LiveIcon } from "./icons/live-icon.svg";

export function LiveButton({ onClick }: { onClick: () => void }) {
  const { isLiveEdge } = useLiveDelay();
  const isLive = useAppSelector((state) => state.player.videoStream.isLive);
  const cameraId = useAppSelector((state) => state.player.videoStream.cameraId);

  return (
    <Flex className="w-[84px]" align="center">
      <Button
        size="2"
        variant="ghost"
        color={isLive && isLiveEdge ? "red" : "gray"}
        className="gap-2"
        onClick={onClick}
      >
        <LiveIcon
          className={
            isLive && isLiveEdge ? "text-red-500" : "text-[var(--gray-8)]"
          }
        />
        {isLive && cameraId ? (isLiveEdge ? "On air" : "Catch up") : "Go live"}
      </Button>
    </Flex>
  );
}
